import { render, staticRenderFns } from "./PromotionPointForm.vue?vue&type=template&id=43fd3efc&"
import script from "./PromotionPointForm.vue?vue&type=script&lang=js&"
export * from "./PromotionPointForm.vue?vue&type=script&lang=js&"
import style0 from "./PromotionPointForm.vue?vue&type=style&index=0&id=43fd3efc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports